import { Select } from 'antd'
import { memo, useMemo } from 'react'
import { useDataStores } from '../hooks'
import { DataStore } from '../store/reducers/dataStoreReducer'

interface SelectOption {
  label: string
  value: string
}

interface SelectStoreProps {
  onChange?: (value: DataStore | undefined) => void
  value?: string
  style?: Object
  placeholder?: string
}

const SelectStore = memo(
  ({ value, onChange, style, placeholder }: SelectStoreProps) => {
    const { dataStoreList } = useDataStores({})

    const options: SelectOption[] | undefined = useMemo(
      () =>
        dataStoreList.map((dataStore: DataStore) => ({
          label: dataStore.title || '',
          value: dataStore.id || '',
        })),
      [dataStoreList]
    )

    const handleChange = (value: string) => {
      if (onChange) {
        const dataStore = dataStoreList.find((store) => store.id === value)
        onChange(dataStore)
      }
    }

    return (
      <Select
        style={style}
        onChange={handleChange}
        value={value}
        options={options}
        placeholder={placeholder ? placeholder : ''}
        allowClear
      />
    )
  }
)

export default SelectStore
